module.exports = __webpack_public_path__ + "img/loader.2ca03723.svg";